import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M18.975 8.55c-.6 0-1.05.45-1.05 1.05 0 .6.45 1.05 1.05 1.05.6 0 1.05-.45 1.05-1.05 0-.6-.45-1.05-1.05-1.05z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M14.25 9.9c-2.475 0-4.425 2.025-4.425 4.425s2.025 4.425 4.425 4.425 4.425-2.025 4.425-4.425S16.725 9.9 14.25 9.9zm0 7.275a2.849 2.849 0 0 1-2.85-2.85 2.849 2.849 0 0 1 2.85-2.85 2.849 2.849 0 0 1 2.85 2.85 2.849 2.849 0 0 1-2.85 2.85z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M17.85 5.25h-7.125c-3.075 0-5.475 2.4-5.475 5.4v7.125c0 3 2.4 5.4 5.4 5.4h7.125c3 0 5.4-2.4 5.4-5.4V10.65c.075-3-2.325-5.4-5.325-5.4zm3.675 12.6c0 2.025-1.65 3.75-3.75 3.75H10.65c-2.025 0-3.75-1.65-3.75-3.75v-7.125c0-2.025 1.65-3.75 3.75-3.75h7.125c2.025 0 3.75 1.65 3.75 3.75v7.125z"
    }, null, -1)
  ])))
}
export default { render: render }